<div class="contenido">

  <h2 class="titulo text-primary text-right">
    <strong class="text-dark">{{titulo}}</strong> <span class="barra">
      █</span>
  </h2>

  <p class="texto ml-5 mr-5">{{descripcion}}
  </p>
</div>
